// The score rules, shared so the client can move the number on tap and the Worker can store
// exactly the same result. The score is a rolling 0-100 number that starts full and never resets.

export const START_SCORE = 100;
export const MIN_SCORE = 0;
export const MAX_SCORE = 100;

/** The sizes a grown-up can tap, each as a plus or a minus: one for small things, ten for big ones. */
export const ALLOWED_DELTAS = [1, 5, 10] as const;

export function clampScore(n: number): number {
  return Math.min(MAX_SCORE, Math.max(MIN_SCORE, n));
}

/** The score once a tap lands. A tap that would cross 0 or 100 stops there. */
export function applyDelta(score: number, delta: number): number {
  return clampScore(score + delta);
}

/** True for +-1, +-5 and +-10 only. Anything else (0, 7, 2.5, "5") is a bad request. */
export function isAllowedDelta(d: unknown): d is number {
  return typeof d === "number" && (ALLOWED_DELTAS as readonly number[]).includes(Math.abs(d));
}

/**
 * Whether a tap may be made at all: a plus that would carry the score past 100 is refused, not
 * clamped, so a "+10" never quietly counts as "+5". A minus at the bottom still stops at 0.
 */
export function fitsCeiling(score: number, delta: number): boolean {
  return delta <= 0 || score + delta <= MAX_SCORE;
}
